import { Country } from 'country-state-city';
import {
  Combobox,
  ComboboxInput,
  ComboboxContent,
  ComboboxList,
  ComboboxItem,
  ComboboxEmpty,
} from '@/components/ui/combobox';

interface CountryOption {
  value: string;
  label: string;
}

interface CountryInputProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

const options: CountryOption[] = Country.getAllCountries().map((c) => ({
  value: c.name,
  label: `${c.flag} ${c.name}`,
}));

export function CountryInput({
  id,
  value,
  onChange,
  onBlur,
  placeholder = 'Select country…',
  disabled,
  className,
}: CountryInputProps) {
  return (
    <Combobox value={value} onValueChange={(val) => onChange(val ?? '')} items={options}>
      <ComboboxInput
        id={id}
        placeholder={placeholder}
        onBlur={onBlur}
        disabled={disabled}
        showClear
        className={className}
      />
      <ComboboxContent>
        <ComboboxEmpty>No country found.</ComboboxEmpty>
        <ComboboxList>
          {(country: CountryOption) => (
            <ComboboxItem key={country.value} value={country.value}>
              {country.label}
            </ComboboxItem>
          )}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
}
